import axios from 'axios';
import { getAuthToken } from 'src/utility/auth';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from 'src/utility/sessionStorage';

// Axios instance replacing advisor-3.0 httpRequest.js
// Bearer token and X-Session-ID injected via interceptors

interface AccountEnvelope {
  sessionId?: string;
  account?: { oneClickAccountId?: number | string };
}

export const apiClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const accountObj = getSessionStorageItem<AccountEnvelope>(SESSION_STORAGE_ACCOUNT_KEY);
  if (accountObj?.sessionId) {
    config.headers['X-Session-ID'] = accountObj.sessionId;
  }

  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/ns';
    } else if (error.response?.status === 403) {
      window.location.href = '/unauthorized';
    }
    return Promise.reject(error);
  },
);
